import { useState } from 'react';
import Sidebar from './Sidebar';
import { Route, Switch } from 'react-router-dom';
import LoggedUserCard from './LoggedUserCard';
import Clients from '../modules/Clients/Clients';
import Products from '../modules/Products/Products';
import Utilisateurs from '../modules/Users/Utilisateurs';
import ClientDetails from '../modules/Clients/ClientDetails';
import Purchases from '../modules/Purchases/Purchases';
import ModuleWrapper from '../components/ModuleWrapper';
import Brands from '../modules/Brands/Brands';
import Families from '../modules/Families/Families';
import Orders from '../modules/Orders/Orders';
import OrderDetails from '../modules/Orders/OrderDetails';
import GlobalSearch from './GlobalSearch';
import Repositories from '../modules/Repo/Repositories';
import Providers from '../modules/Repo/Providers';
import ProductsByRepo from '../modules/Repo/ProductsByRepo';
import Transfers from '../modules/Repo/Transfers';
import Dashboard from '../modules/Dashboard/Dashboard';
import DeliveryNotes from '../modules/DeliveryNotes/DeliveryNotes';
import DeliveryNoteDetails from '../modules/DeliveryNotes/DeliveryNoteDetails';
import DeliveryNoteForm from '../modules/DeliveryNotes/DeliveryNoteForm';
import CreditNotes from '../modules/CreditNotes/CreditNotes';
import CreditNoteDetails from '../modules/CreditNotes/CreditNoteDetails';
import Invoices from '../modules/Invoices/Invoices';
import InvoiceDetails from '../modules/Invoices/InvoiceDetails';
import Expenses from '../modules/Performance/Expences';
import Quotes from '../modules/Quotes/Quotes';
import ExpenseDetails from '../modules/Performance/ExpenseDetails';
import SnackbarNotification from '../components/SnackbarNotification';
import Banks from '../modules/Banks/Banks';
import PaymentTypes from '../modules/PaymentTypes/PaymentsTypes';
import Services from '../modules/Products/Services';
import Materiels from '../modules/Products/Materiels';
import FichesReception from '../modules/FichesReception/FichesReception';
import FicheReceptionDetails from '../modules/FichesReception/FicheReceptionDetails';
import Projects from '../modules/Projects/Projects';
import ProjectDetails from '../modules/Projects/ProjectDetails';
import Calendar from '../modules/Calendar/Calendar';
import { useHistory } from "react-router-dom";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BrandMake from '../modules/BrandMake/BrandMake';
import Insurers from '../modules/Insurers/Insurers';
import VehicleModels from '../modules/VehicleModels/VehicleModels';
import DocumentCategories from '../modules/AttachementDocumentsType/AttachementDocumentsType';
  import Propositions from '../modules/Propositions/Propositions';
import PropositionDetails from '../modules/Propositions/PropositionDetails';

const Layout = () => {
  const layoutStyle = {
    display: 'flex',
    height: '100vh',
    overflowX: 'hidden',
    backgroundColor: '#F9FAFC',

  };

  const blurStyle = {
    position: 'absolute',
    width: '100%',
    height: '150px',
    background: '#3872B0',
    opacity: 0.15,
    filter: 'blur(50px)',
    zIndex: 0,
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '20px 40px',
    gap: '10px',
    zIndex: 1000,
    flexWrap: 'nowrap',
    position: 'sticky',
  };

  const contentStyle = {
    padding: '20px 40px 20px 40px',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    position: 'relative',
    maxWidth: '100vw',
  };

  const history = useHistory();
  const location = useLocation();

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };

  useEffect(() => {
    if (location.state?.showSnackbar) {
      console.log("Snackbar message:", location.state.snackbarMessage);
      showSnackbar(location.state.snackbarMessage, location.state.snackbarSeverity);
      history.replace({ ...location, state: undefined });
    }
  }, [location, history]);


  return (
    <div style={layoutStyle}>
      <div style={blurStyle}></div>
      <div style={{
        flex: '0 0 auto',
        width: '25%',
        minWidth: '220px',
        maxWidth: '270px',
        backgroundColor: '#FFFFFF',
      }}>        
      <Sidebar />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflowX: 'hidden' }}>
        <div style={headerStyle}>
          <GlobalSearch />
          {/* <ExportButton /> */}
          <LoggedUserCard />
        </div>
        {/* Content */}
        <div style={contentStyle}>
          <Switch>

            <Route path="/" exact component={Dashboard} />

            <Route path="/catalog/brands" component={Brands} />
            <Route path="/catalog/families" component={Families} />
            <Route path="/catalog/products" component={Products} />
            <Route path="/catalog/services" component={Services} />
            <Route path="/catalog/materiels" component={Materiels} />

            <Route path="/fiche-reception/details/:id" component={FicheReceptionDetails} />
            <Route path="/fiche-reception" component={FichesReception} />
            
            <Route path="/propositions/details/:id" exact component={PropositionDetails} />
            <Route path="/propositions" exact component={Propositions} />

            <Route
              path="/clients/add"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" />}
            />
            <Route
              path="/clients/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" mode="modify" />}
            />
            <Route
              path="/clients/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="clients" mode="modify" />}
            />
            <Route path="/clients/details/:id" component={ClientDetails} />
            <Route path="/clients" component={Clients} />

            <Route path="/projects/details/:id" component={ProjectDetails} />
            <Route path="/projects" component={Projects} />
            
            <Route
              path="/purchases/add"
              render={(props) => <ModuleWrapper {...props} moduleType="purchases" />}
            />
            <Route path="/purchases/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="purchases" mode="modify" />}
            />
            <Route path="/purchases" component={Purchases} />
            <Route path="/provider-invoices" exact render={(props) => <Purchases {...props} billing />} />

            <Route path="/quotes" component={Quotes} />

            <Route path="/orders/details/:id" component={OrderDetails} />
            <Route path="/orders" component={Orders} />

            <Route path="/delivery-notes/details/:id" component={DeliveryNoteDetails} />
            <Route path="/delivery-notes/add" component={DeliveryNoteForm} />
            <Route path="/delivery-notes" component={DeliveryNotes} />

            <Route path="/invoices/details/:id" component={InvoiceDetails} exact />
            <Route path="/invoices" component={Invoices} exact />

            <Route path="/credit-notes/details/:id" component={CreditNoteDetails} exact />
            <Route
              path="/credit-notes/add-from-delivery-note"
              render={(props) => <ModuleWrapper {...props} moduleType="creditNotesFromDeliveryNote" />}
            />
            <Route path="/credit-notes" component={CreditNotes} exact />
          
            <Route
              path="/expenses/add"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" />}
            />
            <Route
              path="/expenses/details/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" mode="modify" />}
            />
            <Route
              path="/expenses/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="expenses" mode="modify" />}
            />
            <Route path="/expenses/details/:id" component={ExpenseDetails} exact />
            <Route path="/expenses" component={Expenses} exact />

            <Route path="/products-by-repo" component={ProductsByRepo} />
            <Route
              path="/transfers/add"
              render={(props) => <ModuleWrapper {...props} moduleType="requests" />}
            />
            <Route
              path="/transfers/modify/:id"
              render={(props) => <ModuleWrapper {...props} moduleType="requests" mode="modify" />}
            />
            <Route path="/transfers" component={Transfers} />
            <Route path="/repos" component={Repositories} />
            <Route path="/providers" component={Providers} />

            <Route path="/users" component={Utilisateurs} />
            <Route path="/banks" component={Banks} />
            <Route path="/payment-types" component={PaymentTypes} />
            <Route path="/vehicle-brands" component={BrandMake} />
            <Route path="/insurers" component={Insurers} />
            <Route path="/vehicle-models" component={VehicleModels} />
            <Route path="/document-categories" component={DocumentCategories} />

            <Route path="/calendrier" component={Calendar} />
          </Switch>
        </div>
      </div>

      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        manual={snackbar.manual}
      />
    </div>
  );
};

export default Layout;
